<template>
  <b-row>
    <b-col class="d-flex mb-2">
      <div v-if="name" class="patient-name__container flex-grow-1 text-left">
        <span>Patient: {{ name }}</span>
      </div>

      <div v-if="dateOfBirth" class="text-right text-nowrap">
        <span>DOB: {{ dateOfBirth }}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "PatientSummary",

  props: {
    name: {
      type: String,
    },
    dateOfBirth: {
      type: String,
    },
  },
};
</script>

<style scoped>
.patient-name__container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
